import { baseApi } from "../redux/baseAPI";

export const labApi = baseApi.injectEndpoints({
  tagTypes: ['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders'],
  endpoints: (builder) => ({
    getTrends: builder.query({
      query: (data) => {
        return {
          url: `/labs/result_trends.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: (result) =>
        result.data
          ? [
            ...result.data.map(({ id }) => ({ type: "Orders", id })),
            { type: "Orders", id: "LIST" },
          ]
          : [{ type: "Orders", id: "LIST" }],
    }),

    signOrder: builder.mutation({
      query: (data) => {
        return {
          url: `/labs/sign_order.json`,
          method: "post",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      // providesTags: ["labOrder"],
      invalidatesTags: ['LabPendingOrders', 'LabOrdersInNote', 'LabFutureOrders'],
    }),

    getOrders: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["labOrder"],
    }),
    getLabOrdersInNote: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["LabOrdersInNote"],
    }),
    getLabPendingOrders: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["LabPendingOrders"],
    }),
    getLabAwaitingResults: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["LabAwaitingResults"],
    }),
    getLabFutureOrders: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["LabFutureOrders"],
    }),
    getRemark: builder.query({
      query: (data) => {
        return {
          url: `/templates/remarks.json?`,
          method: "GET",
          params: { portal: 'provider', ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      // providesTags: ["labOrder"],
    }),
    getPortalAccess: builder.query({
      query: (data) => {
        return {
          url: `/labs/patient_access.json?`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
    deletLabOrder: builder.mutation({
      query: (body) => ({
        url: `/labs/delete_order.json`,
        method: 'POST',
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders'],
    }),
    updateResult: builder.mutation({
      query: (body) => ({
        url: `/labs/save_results.json`,
        method: 'POST',
        data: body,
        params: { pid: body.pid, skip_auto_accept: body.skip_auto_accept }
      }),
      invalidatesTags: ['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    acknowledgeLabOrder: builder.mutation({
      query: (body) => ({
        url: `/labs/acknowledge.json`,
        method: 'GET',
        params: body
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders'],
    }),
    printLabOrderFile: builder.mutation({
      query: (body) => ({
        url: body.mode == 'order' ? `/labs/requisition_report.json` : `/labs/print_result.json`,
        method: 'POST',
        params: { lab_order_id: body.id, skip_auto_accept: body.skip_auto_accept }
      }),
      invalidatesTags: ['Result'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    getLabRefusal: builder.query({
      query: (data) => {
        return {
          url: `/refusals.json`,
          method: "GET",
          params: data,
        };
      },
      providesTags: ['RefusalLab'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    updateLabRefusal: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/refusals/save.json`,
        method: 'POST',
        data: body
      }),
      invalidatesTags: ['RefusalLab'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    deleteLabRefusal: builder.mutation({
      query: (body) => ({
        url: `/refusals/delete.json`,
        method: 'POST',
        data: body
      }),
      invalidatesTags: ['RefusalLab'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    updateLabOrder: builder.mutation({
      query: (body) => ({
        url: `/labs/new_order.json`,
        method: 'POST',
        data: body,
        params: { pid: body.pid, skip_auto_accept: body.skip_auto_accept }
      }),
      invalidatesTags: ['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders'],
      // invalidatesTags: ['ProviderNoteAPLabs'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    addFavoriteLab: builder.mutation({
      query: (body) => ({
        url: `/labs/add_fav_lab_rad.json`,
        method: 'POST',
        data: body,
        // params: { pid: body.pid }
      }),
      // invalidatesTags: ['Result'],
      invalidatesTags: ['ProviderNoteAPLabs'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    addDocumentLabLab: builder.mutation({
      query: ({ body, pid }) => {
        console.log("body", body, pid);
        return {
          url: `/efax/upload_attachment.json`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: body,
          params: { pid: pid }
        }
      },
      // invalidatesTags: ['Result'],
      // invalidatesTags: ['ProviderNoteAPLabs'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    fetchProviders: builder.query({
      query: (patientId) => {
        return {
          url: `/providers/index.json`,
          method: "GET",
          params: {
            pid: patientId,
          },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    fetchLabsSettings: builder.query({
      query: (data) => {
        return {
          url: `/labs/settings.json?`,
          method: "GET",
          params: data
        }
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
    searchLabObservation: builder.query({
      query: (data) => {
        return {
          url: `/labs/search_lab_observations.json?`,
          method: "GET",
          params: data
        }
      },
      // transformResponse: (response, meta, arg) => response.response,

    }),
    getLabFav: builder.query({
      query: (data) => {
        return {
          url: `/labs/get_fav_labs_rad_list.json`,
          method: "GET",
          params: data
        }
      },
      providesTags: ['FavOrder'],
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getFavOrderDetails: builder.query({
      query: (data) => {
        return {
          url: `/labs/edit_fav_record.json`,
          method: "GET",
          params: data
        }
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    deleteFavOrder: builder.mutation({
      query: (body) => ({
        url: `/labs/delete_fav_lab_rad.json`,
        method: 'POST',
        data: body
      }),
      invalidatesTags: ['FavOrder'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    activeInactiveFavOrder: builder.mutation({
      query: (body) => ({
        url: `/labs/change_status_fav_lab_rad.json`,
        method: 'POST',
        data: body
      }),
      invalidatesTags: ['FavOrder'],
      transformResponse: (response, meta, arg) => response.response,
    }),
    attachCpt: builder.mutation({
      query: (body) => {
        return {
          url: `/labs/can_attach_cpt.json`,
          method: "post",
          data: body
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ['labOrder', 'LabOrdersInNote'],
    }),
    notifyPatient: builder.mutation({
      query: (body) => {
        return {
          url: `/labs/patient_notified.json`,
          method: "post",
          data: body,
          params: {skip_auto_accept: body.skip_auto_accept}
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ['labOrder', 'LabOrdersInNote'],
    }),

    notifyPatients: builder.mutation({
      query: (body) => {
        return {
          url: `/labs/notify_patients.json`,
          method: "post",
          data: body
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ['labOrder', 'LabOrdersInNote'],
    }),
    printTrends: builder.mutation({
      query: (body) => ({
        url: `/labs/result_trends_print.json`,
        method: 'POST',
        data: body
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    printResults: builder.mutation({
      query: (body) => ({
        url: `/labs/print_result.json`,
        method: 'POST',
        params: body
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});


export const { useSignOrderMutation, useAddDocumentLabLabMutation, useGetRemarkQuery, useGetTrendsQuery, useGetOrdersQuery, useGetLabOrdersInNoteQuery, useGetLabPendingOrdersQuery, useGetLabAwaitingResultsQuery, useGetLabFutureOrdersQuery, useUpdateResultMutation, useAcknowledgeLabOrderMutation, useGetLabRefusalQuery, useUpdateLabRefusalMutation,
  useDeletLabOrderMutation, usePrintLabOrderFileMutation, useUpdateLabOrderMutation, useFetchLabsSettingsQuery, useFetchProvidersQuery, useAddFavoriteLabMutation, useSearchLabObservationQuery, useAttachCptMutation, useNotifyPatientMutation, useNotifyPatientsMutation, useGetPortalAccessQuery,
  useDeleteLabRefusalMutation, useGetLabFavQuery, useDeleteFavOrderMutation, useActiveInactiveFavOrderMutation, useGetFavOrderDetailsQuery, usePrintTrendsMutation, usePrintResultsMutation } = labApi;
